import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import DialogLoader from '../../../../components/Loader/DialogLoader';

import { InputBaseField, SelectField } from '../../../../components/InputField/InputField';
import { Label, DraggableComponent } from '../../../../components/UiElements/UiElements'
import { PostDataAPI } from '../../../../Services/APIService';
import { withSnackbar } from "./../../../../components/Message/Alert";
import useStyles from "./styles";
import { handleNumberKeyPress, isDigitsOnly, maskAccountNumber, IsVerizonSIM } from '../../../../../src/components/Common/Extensions';
import { GetUserInfo } from "../../../../Services/GetUserInfo";

import ActivatedMessage from "../activateMessage/ActivatedMessage";


function AddNewLine({ dialogOpenClose, handleClose, handleSuccessClose, accountNumber, isPrepaid, ...props }) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    let user_info = JSON.parse(GetUserInfo());
    const [userInfo, setUserInfo] = useState(user_info.user);
    const [state, setState] = useState({ activationPlanId: '' });
    const { showMessage } = props;
    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
        //List plans according to entered icc (GSM or CDMA)
        if (name == 'icc' && value && value.length >= 9) {
            var isVerzion = IsVerizonSIM(value);
            setWirelessPlans(lstAllWirelessPlans
                .filter(a => a.isGSM != isVerzion || a.value == '')
                .map(plan => ({
                    value: plan.value, label: plan.label,
                    plan_name: plan.plan_name, price: plan.price, isGSM: plan.isGSM
                }))
            );
        }
    }
    const [newPhoneNumber, setNewPhoneNumber] = useState('');
    const [activatedMessage, setActivatedMessage] = useState(false);

    const activateCloseDialog = () => {
        setActivatedMessage(false);
        handleSuccessClose("Line added successfully");
    }
    const [errorMessages, setErrorMessages] = useState({

    });
    const handlePlanChange = (e) => {
        const { name, value } = e.target;
        const selectedText = e.nativeEvent.target.text;
        var objPlan = wirelessPlans.filter(plan => plan.value == value)[0];
        let planName = selectedText.split(' - $')[0];
        let planPrice = objPlan.price;// selectedText.split(' - $')[1];
        setState(prevState => ({
            ...prevState,
            [name]: value,
            packageName: planName,
            packageDisplayName: planName,
            mRC: planPrice
        }))
    }
    const Validate = (errorList) => {
        if (!state.firstName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: false
            }));
        }

        if (!state.lastName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorLastName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorLastName: false
            }));
        }

        if (!state.activationPlanId) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPlanId: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPlanId: false
            }));
        }

        if (!state.icc || state.icc.length < 19) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorIcc: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorIcc: false
            }));
        }

        if (!state.imei || state.imei.length < 15) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorImei: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorImei: false
            }));
        }
        if (!state.zipCode) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZipCode: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZipCode: false
            }));
        }

        if (state.zipCode && !isDigitsOnly(state.zipCode)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidZipCode: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidZipCode: false
            }));
        }

    }


    const addNewNumber = () => {
        //if (state.icc && state.icc.includes('0000')) {
        //    showMessage("Warning", "Activation for these SIMs is Coming Soon", "warning", 3000);
        //    return;

        //}
        let errorList = [];

        Validate(errorList);
        if (errorList.length < 1) {
            setIsLoading(true);
            state.accountNumber = accountNumber;

            state.loginUserName = props.loginUserName;

            //default billing cycle to 17
            state.cycleDay = 17;//date.getDate();
            state.isPrepaid = isPrepaid;
            var method = "telispire/addLineToExistingAccount";
            if (IsVerizonSIM(state.icc)) {
                method = "verizon/addLineToExistingAccount";

            }
            debugger
            if (isPrepaid) {
                state.activationPlanId = parseInt(state.activationPlanId);
            }
            else {
                state.packageName = state.activationPlanId;
                state.activationPlanId = 0;
            }
            PostDataAPI(method, state, true).then((result) => {
                if (result.success && result.data != null) {
                    if (result.data) {
                        setNewPhoneNumber(result.data.mdn);
                        setActivatedMessage(true);
                        // showMessage("Success", "Line added successfully", "success", 3000);
                        //setTimeout(() => { handleSuccessClose(); }, 3000)

                    }
                    else {
                        showMessage("Error", "Error adding new line, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);

            })
        }
    }
    const [wirelessPlans, setWirelessPlans] = useState([]);
    const [lstAllWirelessPlans, setLstAllWirelessPlans] = useState([]);
    const getCustomerPlansPlans = () => {
        var params = {
            code: "get_postpaid_wireless_plans",
            parameters: [userInfo.accountNumber + "", userInfo.hidePlanPriceFlag + ""]
        };
        if (isPrepaid) {
            params = {
                code: "get_prepaid_wireless_plans",
                parameters: [userInfo.accountNumber + "", userInfo.hidePlanPriceFlag + ""]
            };
        }

        PostDataAPI("ddl/loadItems", params).then((result) => {

            if (result.success && result.data != null) {
                result.data.unshift({ t2: 'Please Select Plan', t1: '' });
                var lstPlansData = result.data.map(t => { return { label: t.t2, value: t.t1, plan_name: t.t3, price: t.t4, isGSM: t.t5 == 'True' ? true : false } });
                setWirelessPlans(lstPlansData);
                setLstAllWirelessPlans(lstPlansData);
            }
        })
    }
    const maskedNumber = maskAccountNumber(props.customerNumber);
    useEffect(() => {
        getCustomerPlansPlans();
    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>Add New Line</Typography>

                        <Icon className={classes.closeIcon} color="primary"><CloseIcon onClick={handleClose} /></Icon>
                    </div>


                    {isLoading ? <DialogLoader></DialogLoader> : ''}
                    <Scrollbars autoHeight autoHeightMax={570}>
                        <div className={classes.content}>



                            <Grid container spacing={2}>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Typography className={classes.labelText}><b>Account:</b><span className={classes.valueText}> {maskedNumber} - {props.customerName}</span></Typography>
                                </Grid>


                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <Grid row >
                                        <Label title="First Name" size={4} mandatory={true} />

                                        <InputBaseField
                                            name="firstName"
                                            value={state.firstName}
                                            onChange={handleChange}
                                            placeholder="First Name"
                                            type="text"
                                            MaxLength={50}
                                            onKeyPress={(e) => handleChange(e)}
                                        />
                                        {errorMessages.errorFirstName && !state.firstName ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter first name
                                        </FormHelperText>) : ('')}
                                    </Grid>


                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <Grid row >
                                        <Label title="Last Name" size={4} mandatory={true} />

                                        <InputBaseField
                                            name="lastName"
                                            value={state.lastName}
                                            onChange={handleChange}
                                            placeholder="Last Name"
                                            type="text"
                                            MaxLength={15}
                                            onKeyPress={(e) => handleChange(e)}
                                        />
                                        {errorMessages.errorLastName && !state.lastName ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter last name
                                        </FormHelperText>) : ('')}
                                    </Grid>


                                </Grid>

                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <Grid row >
                                        <Label title="Figgers SIM Number" size={12} mandatory={true} />
                                        <InputBaseField
                                            name="icc"
                                            value={state.icc}
                                            onChange={handleChange}
                                            placeholder="Number"
                                            type="text"
                                            MaxLength={20}
                                            onKeyPress={(e) => handleNumberKeyPress(e)}
                                        />
                                        {errorMessages.errorIcc && (!state.icc || state?.icc.length < 19) ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter valid SIM number
                                        </FormHelperText>) : ('')}
                                    </Grid>

                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <Grid row >
                                        <Label title="IMEI #" size={12} mandatory={true} />

                                        <InputBaseField
                                            name="imei"
                                            value={state.imei}
                                            onChange={handleChange}
                                            placeholder="IMEI"
                                            type="text"
                                            MaxLength={15}
                                            onKeyPress={(e) => handleNumberKeyPress(e)}
                                        />
                                        {errorMessages.errorImei && (!state.imei || state?.imei.length < 15) ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter valid IMEI
                                        </FormHelperText>) : ('')}
                                    </Grid>


                                </Grid>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid row >
                                        <Label title="Plan" size={4} mandatory={true} />

                                        <SelectField
                                            id="activationPlanId"
                                            name="activationPlanId"
                                            options={wirelessPlans}
                                            onChange={handlePlanChange}
                                            value={state?.activationPlanId}
                                        />
                                        {errorMessages.errorPlanId && !state.activationPlanId ? (<FormHelperText style={{ color: "red" }} >
                                            Please select plan
                                        </FormHelperText>) : ('')}
                                    </Grid>


                                </Grid>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid row >
                                        <Label title="Zip / Postal Code" size={12} mandatory={true} />

                                        <InputBaseField
                                            name="zipCode"
                                            value={state.zipCode}
                                            onChange={handleChange}
                                            placeholder="Zip / Postal Code"
                                            type="text"
                                            MaxLength={5}
                                            onKeyPress={(e) => handleNumberKeyPress(e)}
                                        />
                                        {errorMessages.errorZipCode && !state.zipCode ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter Zip / Postal Code
                                        </FormHelperText>) : ('')}

                                        {errorMessages.errorInvalidZipCode && (state.zipCode && !isDigitsOnly(state.zipCode)) ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter valid Zip / Postal Code
                                        </FormHelperText>) : ('')}
                                    </Grid>


                                </Grid>
                            </Grid>

                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            <Button className={classes.changeBtn} onClick={addNewNumber}>Activate</Button>

                        </div>
                    </div>
                </div>
            </div>
            {activatedMessage ?
                <ActivatedMessage
                    dialogOpenClose={activatedMessage}
                    handleClose={activateCloseDialog}
                    accountNumber={accountNumber}
                    phoneNumber={newPhoneNumber}
                    icc={state.icc}

                ></ActivatedMessage>
                : null}
        </Dialog >
    )
}

export default withSnackbar(AddNewLine);
